import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BarList from './BarList';

import transformArrayToBarChartObject from '../utils/transformArrayToBarChartObject';

const ChartWrapper = styled.div`
  height: ${props => props.theme.components.chartHeight};
  display: flex;
`;

function StrengthsVisualisation({ data, ...props }) {
  const transformedData = transformArrayToBarChartObject(
    data?.strengths,
    data?.strengths?.length + 1,
    'value',
  );

  return (
    <ChartWrapper {...props}>
      <BarList data={transformedData} />
    </ChartWrapper>
  );
}

StrengthsVisualisation.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cmsContent: PropTypes.shape({}).isRequired,
};

export default StrengthsVisualisation;
